if (window.location.pathname === '/soplado/periodo' || window.location.pathname === '/zona-trabajo') {

    document.addEventListener('click', function (e) {
        const btnEliminar = e.target.closest('#btnEliminarLoteMateriaPrimaSoplado');
        if (!btnEliminar) return;

        const formEditar  = document.querySelector('#formEditarLoteMateriaPrimaSoplado');
        const formEliminar = document.querySelector('#formEliminarLoteMateriaPrimaSoplado');

        if (!formEditar || !formEliminar) return;

        const inputLineaEditar    = formEditar.querySelector('#idLineaLotePreformaSoplado');
        const inputReporteEditar  = formEditar.querySelector('#idEncabezadoReporteSoplado');

        const inputLineaEliminar   = formEliminar.querySelector('#idLineaLotePreformaSopladoEliminar');
        const inputReporteEliminar = formEliminar.querySelector('#idEncabezadoReporteSopladoEliminar');

        if (!inputLineaEditar || !inputReporteEditar || !inputLineaEliminar || !inputReporteEliminar) {
            lanzarAlerta('Faltan datos para eliminar el lote.', 'alerta-roja');
            return;
        }

        inputLineaEliminar.value   = inputLineaEditar.value   || '';
        inputReporteEliminar.value = inputReporteEditar.value || '';
    });

    document.addEventListener('submit', async function (e) {
        if (e.target.id !== 'formEliminarLoteMateriaPrimaSoplado') return;

        const botonActivo = e.submitter;
        if (!botonActivo || botonActivo.id !== 'btnConfirmarEliminarLoteMateriaPrima') return;

        e.preventDefault();

        const formulario  = e.target;
        const modalEditar = document.querySelector('#modalEditarLoteMateriaPrimaSoplado');
        const modalPadre  = formulario.closest('.modal');
        const btnEliminar = botonActivo;
        const spinner     = btnEliminar.querySelector('#spinner') || formulario.querySelector('#spinner');

        if (btnEliminar) btnEliminar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(el => el.classList.remove('inputRojo'));

        try {
            const formData = new FormData(formulario, botonActivo);

            const respuesta = await fetch('/api/soplado/eliminar-lote-materia-prima', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            let json;
            try {
                json = await respuesta.json();
            } catch {
                throw new Error('La respuesta del servidor no es JSON válido.');
            }

            if (!respuesta.ok) {
                lanzarAlerta('Error al procesar la eliminación.', 'alerta-roja');
                return;
            }

            if (!json.result) {
                lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
                return;
            }

            const resultado = json.result;

            if (resultado.hayErrores) {
                resultado.errores.forEach(function (error) {
                    lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                    if (error.campo) {
                        const campo = formulario.querySelector('[name="' + error.campo + '"]');
                        if (campo) campo.classList.add('inputRojo');
                    }
                });
                return;
            }

            const idReporte = formulario.querySelector('#idEncabezadoReporteSopladoEliminar').value;
            const params    = new URLSearchParams(window.location.search);
            const mes       = params.get('mes');
            const anio      = params.get('año');

            if (modalPadre) modalPadre.classList.remove('modal--show');
            if (modalEditar) modalEditar.classList.remove('modal--show');

            lanzarAlerta(resultado.mensaje || 'Lote eliminado con éxito.', 'alerta-verde');

            window.actualizarModalReporteSoplado(idReporte);
            window.actualizarTableroSopladoPeriodo(mes, anio);
            window.actualizarTablaSopladoPeriodo(mes, anio);
            if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();

        } catch (error) {
            console.error('Error:', error);
            lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
        } finally {
            if (btnEliminar) btnEliminar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    });
}
